// Design tone palette — the project's Tailwind config overrides the default
// color palette, so we reference these via inline `style={{}}` for tone-specific
// chips/cards/badges.
export const TONES = {
  blue:   { bg: "#E8F1FF", fg: "#1E63D6" },
  green:  { bg: "#E6F6EC", fg: "#15803C" },
  purple: { bg: "#F0E9FF", fg: "#7C3AED" },
  gold:   { bg: "#FBF0DC", fg: "#B7791F" },
  amber:  { bg: "#FFF3D6", fg: "#9A6700" },
  teal:   { bg: "#DCF5F3", fg: "#0F766E" },
  red:    { bg: "#FCE7E9", fg: "#B91C1C" },
  slate:  { bg: "#F1F5F9", fg: "#475569" },
};

export const STATUS_TONE = {
  draft: "slate",
  scheduled: "blue",
  active: "green",
  paused: "amber",
  expired: "red",
  inactive: "red",
  archived: "slate",
  // Coupon-code statuses pass through the same map.
  available: "slate",
  issued: "blue",
  redeemed: "green",
  disabled: "red",
};
